import {
  required,
  numeric,
  nonNumeric,
  exactLength,
  validStreetNumber,
} from '@origin-digital/validation';

import {
  validLotNumber,
  validStreetNumberWithoutLot,
  validUnitNumber,
  validUnitType,
} from './helpers';

import { content } from './content';

export const metadata = {
  postcode: {
    label: content.postcode.label,
    validators: [
      required({ error: content.postcode.errors.required }),
      numeric({
        error: content.postcode.errors.numeric,
      }),
      exactLength({ error: content.postcode.errors.exactLength, amount: 4 }),
    ],
  },

  state: {
    label: content.state.label,
    validators: [required({ error: content.state.errors.required })],
  },

  streetNumber: {
    label: content.streetNumber.label,
    validators: [
      validStreetNumber({
        error: content.streetNumber.errors.validStreetNumber,
      }),
      validStreetNumberWithoutLot({
        error: content.streetNumber.errors.required,
      }),
    ],
  },

  streetName: {
    label: content.streetName.label,
    validators: [
      required({ error: content.streetName.errors.required }),
      nonNumeric({
        error: content.streetName.errors.nonNumeric,
      }),
    ],
  },

  streetType: {
    label: content.streetType.label,
    validators: [required({ error: content.streetType.errors.required })],
  },

  streetTypeSuffix: {
    label: content.streetTypeSuffix.label,
    validators: [],
  },

  city: {
    label: content.city.label,
    validators: [
      required({ error: content.city.errors.required }),
      nonNumeric({
        error: content.city.errors.nonNumeric,
      }),
    ],
  },

  unitType: {
    label: content.unitType.label,
    validators: [validUnitType({ error: content.unitType.errors.required })],
  },

  unitNumber: {
    label: content.unitNumber.label,
    validators: [validUnitNumber({ error: content.unitNumber.errors.required })],
  },

  allotment: {
    label: content.allotment.label,
    validators: [validLotNumber({ error: content.allotment.errors.notRequired })],
  },
};
